document.addEventListener("DOMContentLoaded", function () {

    const salesDiv = document.getElementById("dynamic-sales");

if (!salesDiv) return;

// Hide sales counter if product is sold out
const addToCartBtn = document.querySelector(
    '.product-form__submit[name="add"]'
);

if (addToCartBtn && addToCartBtn.disabled) {
    salesDiv.style.display = "none";
    return;
}

    const tags = salesDiv.dataset.tags.toLowerCase();

    let minSold = 5;
    let maxSold = 15;

    if (tags.includes("DIY")) {
        minSold = 20;
        maxSold = 40;
    }
    else if (tags.includes("best")) {
        minSold = 15;
        maxSold = 30;
    }
    else if (tags.includes("Teddy")) {
        minSold = 10;
        maxSold = 20;
    }
    else if (tags.includes("dtf")) {
        minSold = 5;
        maxSold = 15;
    }
    else if (tags.includes("new")) {
        minSold = 1;
        maxSold = 8;
    }

    // const sold = Math.floor(Math.random() * (maxSold - minSold + 1)) + minSold;
    // const hours = Math.floor(Math.random() * 18) + 6;

// Stable daily seed
const today = new Date();

const seed =
    today.getFullYear() * 10000 +
    (today.getMonth() + 1) * 100 +
    today.getDate();

// Use tags instead of undefined title
let tagSeed = 0;

for (let i = 0; i < tags.length; i++) {
    tagSeed += tags.charCodeAt(i);
}

const productSeed = seed + tagSeed;

// Stable pseudo random
function stableRandom(seed) {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
}

const sold =
    Math.floor(stableRandom(productSeed) * (maxSold - minSold + 1)) + minSold;

const hours =
    Math.floor(stableRandom(productSeed + 99) * 18) + 6;

    salesDiv.innerHTML = `
        <div class="sales-counter">
            🔥 <strong>${sold}</strong> sold in last <strong>${hours}</strong> hours
        </div>
    `;

});